import { MessagesScreen } from '~/components/domain/messages/MessagesScreen';

export default function MessagesOnline() {
  return <MessagesScreen initialMessageType="online" />;
} 